module.exports = "/images/line-top-left-bottom-right.svg?74e04ae091704f38159260ac2592386f";